// rgba(225, 245, 255, 1)

import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

const useOverallPeriodStyles = makeThemedStyles("OverallPeriod", (theme) => ({
  root: {
    margin: 0,
    letterSpacing: "0.05625px",
    fontSize: "1.4em",
    lineHeight: "1.42em",
    fontWeight: 600,
    marginTop: "0.142em",
    color: "rgba(105, 112, 117, 1)",
  },
}));

const OverallPeriod = (props: React.PropsWithChildren<{}>) => {
  const styles = useOverallPeriodStyles();
  return <div className={styles.root}>{props.children}</div>;
};

export default OverallPeriod;
